import Dexie from 'dexie'

export const db = new Dexie('Unusuals')
db.version(5).stores({
  inspections: 'id, [id+username], lastImageVisited', // Primary key and indexed props
})
